import { render } from "./VehiculoList.vue?vue&type=template&id=e53aa064&scoped=true"
import script from "./VehiculoList.vue?vue&type=script&lang=js"
export * from "./VehiculoList.vue?vue&type=script&lang=js"

import "./VehiculoList.vue?vue&type=style&index=0&id=e53aa064&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e53aa064"]])

export default __exports__